/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/member-ordering */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalsComponent } from 'app/shared/modals/modals.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { RestService } from 'app/shared/rest.service';
import { boardNameHotel, getCommentadjective, routeIconsBoardnameHotel, starsHotels } from './information/categories/hotel-result/hotel-result-funtions';
import { DatePipe } from '@angular/common';
import { flagByLanguageNameExperience, languageArrayExperience } from './information/categories/activities-result/activities-result-function';
import { ICancellationPolicyDisplayData, IPriceDisplayData } from 'model/view-models/results/product-card/price-display-data.interface';
import { CurrencyConverterPurePipe } from 'app/shared/currency-converter-pure.pipe';
import { TransportsService } from 'app/shared/modals/modal-transports/transports.service';
import { initArrayIncludesCoverageRentACar, ratingAccriss } from './information/categories/rent-a-car-result/rent-a-car-result-functions';
import { NotificationService } from 'app/shared/notifications/notification.service';
import { DetailModalFlightResultComponent } from './information/categories/flight-result/detail-modal-flight-result/detail-modal-flight-result.component';


@Component({
  selector: 'usb-base-result',
  templateUrl: './base-result.component.html',
  styleUrls: ['./base-result.component.scss'],
  providers: [DatePipe, CurrencyConverterPurePipe ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BaseResultComponent implements OnInit, OnChanges {

  @Input() result: any;
  @Input() clientsSettingAppBooking: any;
  @Input() currencyAgency: any;
  @Input() views: any;
  @Input() payload: any;
  @Input() formData: any;
  @Input() currencies: any;
  @Input() paymentAgencyActive: any;
  @Input() arrayResults: any;
  @Input() form: any;
  @Input() formTransports: any;
  @Input() index = 0;
  @Input() _actualItinerary: any;
  @Input() stylePathPrice: any;

  hoverStates: { [key: number]: boolean } = {};

  private originalResult: any;

  // HOTEL
  @Input() qtyProductValid: any;
  @Output() qtyProductValidDecrementEmmitChild = new EventEmitter<any>();
  @Output() modalClosedemitterChild = new EventEmitter<any>();

  // Búsqueda de vuelos "Por tramos": cuando está en true, el modal de detalle
  // no crea el producto al elegir tarifa — sólo la devuelve, para que quien
  // orquesta la selección tramo por tramo decida cuándo crear los productos.
  @Input() deferFlightCreation = false;
  @Output() flightFareSelectedForLeg = new EventEmitter<{ offer: any; fare: any }>();

  ModalRooms: any;

  // RENT A CAR
  public includesRentacar: any[] = [];

  public modalRef: BsModalRef | undefined;
  typeLocations: string;
  public categoryId = 0;

  modalTours: any;
  constructor(public dialog: MatDialog,
              private restService: RestService,
              private notificationService: NotificationService,
              private currencyPipe: CurrencyConverterPurePipe,
              private transportService: TransportsService,
              private modalService: BsModalService
            ) { }


  ngOnInit(): void {
    this.originalResult = this.deepCopy(this.result);
    if(this.payload ) {
      if(Array.isArray(this.payload)) {
         this.categoryId = this.payload[0].categoriesId[0];
      } else {
      this.categoryId = this.payload.categoriesId[0];
      }
    }

    if(this.categoryId) {
        this.initializeValuesForCategory(this.categoryId);
    }
  if(this.categoryId === 1) {

      this.sumTaxExcluded();

  }

  if(this.categoryId === 5) {

    this.setTitleFlight();

  }


  if(this.categoryId === 8) {




      this.transportService.initializeAssignment(this.payload.transfers.paxList);


  }


  }

    sumTaxExcluded(): void {

        if(this.result && this.result?.additionalInfo && Array.isArray(this.result.additionalInfo?.rooms) && this.result.additionalInfo?.rooms.length > 0) {
            this.result.additionalInfo?.rooms.forEach((room: any) => {
                // La condición estaba invertida: sumaba los taxes con included=true (los que
                // ya están en el precio) y descartaba los included=false, dando taxesExcluded
                // en 0 salvo que hubiera algún tax incluido. Debe sumar solo los NO incluidos.
                room.room.pricing.taxesExcluded = (room.room.pricing?.taxes || [])
                  .reduce((total, tax) => tax.included ? total : total + Number(tax.amount), 0);
          });
        } else {

        }
  }

  setTitleFlight(): void {

    if(
      this.result &&
       Array.isArray(this.result?.itinerary) &&
      this.result?.itinerary.length > 0 &&
      Array.isArray(this.result?.itinerary[0]?.options) &&
      this.result?.itinerary[0]?.options.length > 0 &&
      Array.isArray(this.result?.itinerary[0]?.options[0]?.segments) &&
      this.result?.itinerary[0]?.options[0]?.segments.length > 0
    ) {
      this.result.title = this.result?.itinerary[0]?.options[0]?.segments[0]?.airline?.name;
    }

  }

  ngOnChanges(changes: SimpleChanges): void {
  let needsUpdate = false;

  // Actualizar result
  if (changes['result']) {
    this.originalResult = this.deepCopy(changes['result'].currentValue);
    needsUpdate = true;
  }

  // Actualizar categoryId desde payload
  if (changes['payload']) {
    const currentPayload = changes['payload'].currentValue;
    if(changes['payload'].currentValue !== changes['payload'].previousValue){
      this.payload = changes['payload'].currentValue;
    }
    if (currentPayload && Array.isArray(currentPayload)) {
      this.categoryId = currentPayload[0]?.categoriesId?.[0];
    } else if (currentPayload?.categoriesId) {
      this.categoryId = currentPayload.categoriesId[0];
    }
    needsUpdate = true;
  }

  // Actualizar stylePathPrice
  if (changes['clientsSettingAppBooking']) {
    const setting = changes['clientsSettingAppBooking'].currentValue;
    if (setting?.clients_setting_app_booking?.bookingFlow_body) {
      this.stylePathPrice = JSON.parse(setting.clients_setting_app_booking.bookingFlow_body);
    }
    needsUpdate = true;
  }

  // Actualizar otras propiedades simples
  if (changes['currencyAgency']) {
this.currencyAgency = changes['currencyAgency'].currentValue;
}
  if (changes['views']) {
this.views = changes['views'].currentValue;
}
  if (changes['formData']) {
this.formData = changes['formData'].currentValue;
}
  if (changes['currencies']) {
this.currencies = changes['currencies'].currentValue;
}
  if (changes['paymentAgencyActive']) {
this.paymentAgencyActive = changes['paymentAgencyActive'].currentValue;
}
  if (changes['arrayResults']) {
this.arrayResults = changes['arrayResults'].currentValue;
}
  if (changes['form'] && this.categoryId !== 8) {
this.form = changes['form'].currentValue;
}
if (changes['formTransports']) {
this.form = changes['formTransports'].currentValue;
}
  if (changes['index']) {
this.index = changes['index'].currentValue;
}
  if (changes['qtyProductValid']) {
this.qtyProductValid = changes['qtyProductValid'].currentValue;
}

  // Si hubo cambios relevantes, reinicializar
  if (needsUpdate) {
    this.initializeValuesForCategory(this.categoryId);
    // this.result.additionalInfo.rooms[0].room.pricing.taxes[0].excluded = true;
    // this.result.additionalInfo.rooms[0].room.pricing.taxes[0].excluded = true;
    this.sumTaxExcluded();
  }

  // if(this.categoryId === 8) {
  //      this.transportService.initializeAssignment(this.payload.transfers.paxList);

  //       this.transportService.assignment$.subscribe(assignment => {
  //         if (assignment && this.transportService.isAssignmentComplete()) {
  //         }
  //       });
  //   }
}

get pricesData(): IPriceDisplayData {
    return {
    price: this.calculatePrice(this.result),
    originalPrice: this.getOriginalPrice(this.result),
    currency: this.currencyAgency?.code,
    originalCurrency: this.getOriginalCurrency(this.result),
    totalLabel: this.getTotalLabel()
  };
}

get cancellationPolicyData(): ICancellationPolicyDisplayData {
  return {
       isRefundable: this.getRateClass(this.result) === 'R' ? true : false,
       refundableUntil: this.getDateCancellationPolicy(this.result),
       penaltyAmount: 0,
       penaltyPercentage: 0,
       displayText: this.getRateClass(this.result) === 'R' ? 'Reembolsable' : 'No reembolsable',
       displayColorText: this.getRateClass(this.result) === 'R' ? '#02d498' : '#ed3b5b',
  };
}

get promotionsApplied(): any {
  return {
    promotion: this.getPromotionsApplied(this.result),
    itemCurrency: this.getOriginalCurrency(this.result),
  };
}




    openModal(template: TemplateRef<any>, tab: any) {



      this.updateView();

      switch(this.categoryId) {
        case 1:
          if (this.qtyProductValid > 0) {

            // const payloadHotel = { ...this.payload };
            // payloadHotel["hotels"] = [this.result.id];
            // payloadHotel["destination"] = null;

            // // ✅ Guardar suscripción para limpiar después
            // const searchSubscription = this.restService.doPost("app", "search", payloadHotel).subscribe({
            //   next: (res: any) => {
            //     if (res.results && Array.isArray(res.results) && res.results[0]) {


                      //  res.results.forEach((result) => {

// this.result.additionalInfo.rooms[0].room.extras.push(


//                                             {
//                                                 "extraid": "13202913",
//                                                 "title": "",
//                                                 "description": "",
//                                                 "extratypeid": null,
//                                                 "requiresflightdetails": false,
//                                                 "ismandatory": "false",
//                                                 "isopaque": false,
//                                                 "isbindingprice": false,
//                                                 "options": [
//                                                     {
//                                                         "optionid": "13202913",
//                                                         "title": "Basic Supplement (Hotel direct payment)",
//                                                         "description": "",
//                                                         "netcost": {
//                                                             "amount": 13.21,
//                                                             "currency": "USD",
//                                                             "amountprof": 13.21
//                                                         },
//                                                         "grosscost": null
//                                                     },

//                   // {

//                   //   "extraid": "1762244043",
//                   //       "extraTypeid": "3",
//                   //       "isbindingPrice": false,
//                   //         "ismandatory": false,
//                   //         "isopaque": false,
//                   //         "options": [
//                                                     {
//                                                       "description": "Daily resort fee as shown on some booking platforms",
//                                                        "grosscost": null,
//                                                         "netcost": { "amount": 29.4,"currency": "USD", "amountProf": 29.4},
//                                                         "optionid": "1762244043",
//                                                         "title": "Resort Fee",



//                                                     }
//                                                 ],
//               // "requiresflightdetails": false,
//               //  "title": "Daily resort fee",
//         "type": "Hotel Supplements",








//             },
//       {
//   "type": "Hotel Supplements",
//   "extraid": "1762244043",
//   "extraTypeid": "3",
//   "title": "Hotel Supplements",           // ← Cambiar de "Daily resort fee" a "Hotel Supplements"
//   "description": "",                       // ← Puede ir vacío
//   "ismandatory": false,                    // ← Asegurar boolean
//   "options": [
//     {
//       "optionid": "1762244043",            // ← Este debe ser consistente
//       "title": "Resort Fee",               // ← Este es el título que se muestra
//       "description": "Daily resort fee as shown on some booking platforms",
//       "netcost": {
//         "amount": 29.4,
//         "amountProf": 29.4,
//         "currency": "USD"
//       }
//     }
//   ]
// },
//             {
//               extraid: "80",
//               extraTypeid: "1",
//               isbindingPrice: false,
//               ismandatory: false,
//               isopaque: false,
//               options: [
//                 {
//                   description: "esto es la description",
//                   grosscost: null,
//                   netcost: {amount: 90.49, currency: 'USD', amountProf: 95.21},
//                   optionid: "107",
//                   title: "Return speed boatTransfer"
//                 },
//                 {
//                   description: "esto es la description 2",
//                   grosscost: null,
//                   netcost: {amount: 150.49, currency: 'USD', amountProf: 155.21},
//                   optionid: "108",
//                   title: "Return speed boatTransfer float"
//                 },
//                  {
//                   description: "esto es la description 3",
//                   grosscost: null,
//                   netcost: {amount: 175.49, currency: 'USD', amountProf: 185.21},
//                   optionid: "109",
//                   title: "Return speed boatTransfer boat"
//                 }
//               ],
//               requiredflightsdetails: false,
//               title: "Return transfer",
//               type: "Transfer"
//             },
//             {
//               extraid: "81",
//               extraTypeid: "2",
//               isbindingPrice: false,
//               ismandatory: true,
//               isopaque: false,
//               options: [
//                 {
//                   description: "esto es la description",
//                   grosscost: null,
//                   netcost: {amount: 20.49, currency: 'USD', amountProf: 25.21},
//                   optionid: "110",
//                   title: "Esto es una atraccion"
//                 },
//                 {
//                   description: "esto es la description 2",
//                   grosscost: null,
//                   netcost: {amount: 45.49, currency: 'USD', amountProf: 55.21},
//                   optionid: "111",
//                   title: "Esto es una atraccion 2"
//                 }
//               ],
//               requiredflightsdetails: true,
//               title: "Attractions",
//               type: "Attractions"
//             },
//             {
//               extraid: "82",
//               extraTypeid: "3",
//               isbindingPrice: false,
//               ismandatory: false,
//               isopaque: false,
//               options: [
//                 {
//                   description: "park access cowboys adventure",
//                   grosscost: null,
//                   netcost: {amount: 55.49, currency: 'USD', amountProf: 65.21},
//                   optionid: "112",
//                   title: "Result fee includes"
//                 }
//               ],
//               requiredflightsdetails: false,
//               title: "Hotel Supplements",
//               type: "Hotel Supplements"
//             },
// )
                  //  const hotel = res.results[0];
                  // console.log(hotel)
                  const dialogRef = this.dialog.open(ModalsComponent, {
                    width: '100%',
                    height: '100%',
                    maxWidth: '1240px',
                    panelClass: 'custom-container-transport',
                    disableClose: true,
                    data: {
                      modalRoomRef: this.modalRef,
                      product: this.deepCopy(this.result),
                      departureDate: this.payload.departureDate,
                      arrivalDate: this.payload.arrivalDate,
                      productQty: this.payload.qtyProduct,
                      form: this.form,
                      origin: 'HOTELS',
                      arrayResults: this.arrayResults,
                      tabActive: tab !== '' ? tab : 'rooms',
                      payload: this.payload,
                      paymentAgencyActive: this.paymentAgencyActive,
                      quote: true,
                      action: 'results'
                    },
                  });

                  // ✅ Suscripción con manejo de cleanup
                  const dialogSubscription = dialogRef.afterClosed().subscribe((result) => {
                    if (result === 'productAdd') {
                      this.result = this.deepCopy(this.originalResult);
                      this.sumTaxExcluded();
                      this.qtyProductValidDecrementEmmitChild.emit();
                      this.modalClosedemitterChild.emit();
                    }
                    // Limpiar suscripción del diálogo
                    dialogSubscription.unsubscribe();
                  // });
                // }
            //   },
            //   error: (error: HttpErrorResponse) => {
            //     console.log(error);
            //   },
            //   complete: () => {
            //     // Limpiar suscripción HTTP
            //     searchSubscription.unsubscribe();
            //   }
            });

          } else {
            this.notificationService.info('Usted ya eligió todos los productos para la búsqueda realizada');
          }
        break;
        case 2:
          var dialogRef = this.dialog.open(ModalsComponent, {
                  width: '100%',
                  height: '100%',
                  maxWidth: '950px',
                  panelClass: 'custom-container-transport',
                  data: {
                    modalRoomRef: this.modalRef,
                    product:  this.deepCopy(this.result),
                    productQty: this.payload.qtyProduct,
                    form: this.form,
                    origin: 'RENT-A-CAR',
                    arrayResults: this.arrayResults,
                    tabActive: tab !== '' ? tab : 'INCLUDES',
                    payloadUpdate: this.payload,
                    quote: true,
                    action: 'results'
                  },

                  //disableClose: true
                });

                dialogRef.afterClosed().subscribe((result) => {
                  if(result){
                    this.result = this.deepCopy(this.originalResult);
                    // this.spinner.show();
                  }
                });
            break;
          case 5:
                this.openModalDetail(this.deepCopy(this.result));
            break;
          case 6:
          case 9:
          var dialogRef = this.dialog.open(ModalsComponent, {
            width: '100%',
            height: '100%',
            maxWidth: '950px',
            panelClass: 'custom-container-transport',
            disableClose: true,
            data: {
              modalRoomRef: this.modalRef,
              product: this.deepCopy(this.result),
              productQty: this.payload.qtyProduct,
              form: this.form,
              origin: 'TOURS',
              arrayResults: this.arrayResults,
              tabActive: tab !== '' ? tab : 'tour',
              payloadUpdate: this.payload,
              paymentAgencyActive: this.paymentAgencyActive,
              quote: true,
              action: 'results',
              openInfoDescription: tab === 'info' ? true : false
            },
            //disableClose: true
          });

          dialogRef.afterClosed().subscribe(result => {
            if(result){
              this.result = this.deepCopy(this.originalResult);
              // this.spinner.show();
            }
          });

          break;

          case 8:

          console.log(this.payload)

                var dialogRef = this.dialog.open(ModalsComponent, {
                  width: '100%',
                  height: '100%',
                  maxWidth: '1240px',
                  panelClass: 'custom-container-transport',
                  data: {
                    modalRoomRef: this.modalRef,
                    product:  this.deepCopy(this.result),
                    flyingInfo: this._actualItinerary?.flights || [],
                    formTransport: this.form,
                    departureDate: this.payload.departureDate,
                    productQty: this.payload.qtyProduct,
                    form: this.form,
                    origin: 'TRANSPORTS',
                    arrayResults: this.arrayResults,
                    payload: this.payload,
                    paymentAgencyActive: this.paymentAgencyActive,
                    tabActive: 'product',
                    quote: true,
                    action: 'results'
                  },
                });
                dialogRef.afterClosed().subscribe((result) => {
                  if(result === 'add') {
                    this.modalClosedemitterChild.emit('add');
                  }
                  if(result === 'close') {
                    this.modalClosedemitterChild.emit('close');
                  }
                });

            break;

      }

    }

    private deepCopy(obj: any): any {
    if (obj === null || typeof obj !== 'object') {
return obj;
}
    if (obj instanceof Date) {
return new Date(obj.getTime());
}
    if (obj instanceof Array) {
return obj.map(item => this.deepCopy(item));
}

    const copiedObj = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        copiedObj[key] = this.deepCopy(obj[key]);
      }
    }
    return copiedObj;
  }

    updateView(): void {

      let payloadSearch: any;

      if(this.payload && Array.isArray(this.payload)) {
        payloadSearch = this.payload[0];
      } else {
        payloadSearch = this.payload;
      }

    const payload = {
      categoryId:  payloadSearch?.categoriesId[0] || 1,
    };

    if (!this.views) {
      this.restService.doPut('app', 'products/updateView/' + this.result.productId, payload).subscribe(
        (res: any) => {
          if (res.success) {
            this.views = res?.res?.qtyview;
          }
        },
        (error) => {
          console.log('error', error);
        },
      );
    }
  }

  stingUpperCase(str) {

    if(!str) {
      return;
    }

    const e = str.toLowerCase();
    return e.replace(/\b\w/g, (l) => l.toUpperCase());
  }

  getLogoAlliance(product: any): string | null {
    if(this.categoryId !== 5) {
      return null;
    }
    return product?.itinerary[0]?.options[0]?.segments[0]?.airline?.alliance?.logo || '';
  }

  // Equipaje incluido en el primer segmento del vuelo — "carryOn" (bolso de
  // mano) o "checked" (maleta despachada). Si el proveedor no informa el
  // dato (undefined), se asume incluido para no opacar el ícono sin certeza.
  hasFlightBaggage(product: any, type: 'carryOn' | 'checked'): boolean {
    if(this.categoryId !== 5) {
      return true;
    }
    const pieces = product?.itinerary?.[0]?.options?.[0]?.segments?.[0]?.baggage?.[type]?.pieces;
    return pieces === undefined || pieces === null || pieces > 0;
  }

  getImagePortrait(product: any): string {

    let route = '';

    switch(this.categoryId) {
      case 1:
        route = product?.additionalInfo?.images.find(c => c.is_cover === 1) ?
                this.result?.additionalInfo?.images.find(c => c.is_cover === 1).thumbnail :
                '/assets/img/app/hotel_default.png';
        break;
      case 2:
        if(product?.additionalInfo?.images && product?.additionalInfo?.images.length > 0) {
          route = product?.additionalInfo?.images[0].thumbnail;
        } else {
          route = '';
        }

        break;
      case 5:
        route = product?.itinerary[0]?.options[0]?.segments[0]?.airline?.operatingLogo || '/assets/img/app/flight_default.png';
        break;
      case 6:
      case 9:
        if(product?.additionalInfo?.images && product?.additionalInfo?.images.length > 0) {
          route = product?.additionalInfo?.images[0]?.thumbnail || product?.additionalInfo?.images;
        } else {
          route = '';
        }
        break;
      case 8:
        route = product?.vehicles[0]?.images.find(c => c.is_cover === 1) ?
                product?.vehicles[0]?.images.find(c => c.is_cover === 1).thumbnail :
                '/assets/img/app/hotel_default.png';
        break;
    }

    return route;
  }


  getPromotions(product: any): boolean {

    let promotion = false;

    switch(this.categoryId) {

      case 1:
        promotion = product?.additionalInfo?.rooms[0]?.room?.promotions &&
                    product?.additionalInfo?.rooms[0]?.room?.promotions.promotionApplied &&
                    product?.additionalInfo?.rooms[0]?.room?.promotions.promotionApplied.length > 0;
        break;
      case 2:
        promotion = false;
        break;

    }

    return promotion;

  }

  getPromotionsApplied(product: any): any[] {
       let promotionApplied: any[] = [];

    switch(this.categoryId) {

      case 1:
        promotionApplied = product?.additionalInfo?.rooms[0]?.room?.promotions && product?.additionalInfo?.rooms[0]?.room?.promotions?.promotionApplied && product?.additionalInfo?.rooms[0]?.room?.promotions?.promotionApplied.length > 0 ? product?.additionalInfo?.rooms[0]?.room?.promotions?.promotionApplied[0] : [];
        break;
      case 6:
        promotionApplied = product?.additionalInfo?.tours?.options[0]?.promotions && product?.additionalInfo?.tours?.options[0]?.promotions.length > 0 ? product?.additionalInfo?.tours?.options[0]?.promotions : [];
        break;
    }

    return promotionApplied;
  }

  calculatePrice(product: any): number {

    let price = 0;
    switch(this.categoryId) {

      case 1:

      const productPrice = product?.additionalInfo?.rooms[0]?.room?.optionNightsNetTotalProf + Number(product?.additionalInfo?.rooms[0]?.room?.pricing?.taxesExcluded);

      price = this.currencyPipe.transform(productPrice,
                                          product?.additionalInfo?.rooms[0]?.room?.pricing?.currency,
                                          this.currencyAgency.code,
                                          this.currencies);
        break;
      case 2:
        const priceTotal = Number(product?.additionalInfo?.carRental?.totalPriceProf) + Number(product?.additionalInfo?.carRental?.mandatoryPriceProf);

        price = this.currencyPipe.transform(Number(priceTotal),
                                            product?.additionalInfo?.carRental?.currency,
                                            this.currencyAgency.code,
                                            this.currencies);
        break;
      case 5:

        const priceAdultFly = product.passengers.find(c => c.type === 'ADT');

        if(priceAdultFly) {
            price = this.currencyPipe.transform(priceAdultFly?.price?.total,
                                            product?.price?.currency,
                                            this.currencyAgency.code,
                                            this.currencies);

        }

        break;
      case 6:
      case 9:
        const priceAdult = product.additionalInfo?.tours?.options[0]?.profility.find(c => c.paxType === 'ADULT');

        if(priceAdult) {
            price = this.currencyPipe.transform(priceAdult?.netPriceBooking,
                                            product?.additionalInfo?.currency,
                                            this.currencyAgency.code,
                                            this.currencies);

        }

        break;
      case 8:
        price = this.currencyPipe.transform(product['vehicles'][0].totalPriceProf,
                                            product['vehicles'][0]['pricing']?.currency,
                                            this.currencyAgency.code,
                                            this.currencies);
        break;

    }


    return Number(price);
  }

  getOriginalCurrency(product: any): string {

    let currency = '';
    switch(this.categoryId) {

      case 1:
      currency = product?.additionalInfo?.rooms[0]?.room?.pricing?.currency ;
        break;
      case 2:
        currency = product?.additionalInfo?.carRental?.currency;
        break;
      case 5:
        currency = product?.price?.currency;
        break;
      case 6:
      case 9:
        currency = product?.additionalInfo?.currency;
        break;
      case 8:
        currency = product['vehicles'][0]['pricing']?.currency;


    }

    return currency;
  }

  getOriginalPrice(product: any): number {

      let price = 0;

    switch(this.categoryId) {

      case 1:
        price = product?.additionalInfo?.rooms[0]?.room?.optionNightsNetTotalProf + Number(product?.additionalInfo?.rooms[0]?.room?.pricing?.taxesExcluded);
        break;
      case 2:
        const priceTotal = Number(product?.additionalInfo?.carRental?.totalPriceProf) + Number(product?.additionalInfo?.carRental?.mandatoryPriceProf);
        price = priceTotal;
        break;
      case 5:
        const priceAdultFly = product.passengers.find(c => c.type === 'ADT');
        price = priceAdultFly?.price?.total;
        break;
      case 6:
      case 9:
        const priceAdult = product.additionalInfo?.tours?.options[0]?.profility.find(c => c.paxType === 'ADULT');
        price = priceAdult?.netPriceBooking;
        break;
      case 8:
        price = product['vehicles'][0].totalPriceProf;

    }

    return price;
  }

    private getTotalLabel(): string {
    const labels: Record<number, string> = {
      1: 'Total Estadia',
      2: 'Total Viaje',
      6: 'Total Viaje',
      8: 'Total Viaje',
      9: 'Total Viaje'
    };
    return labels[this.categoryId] || 'Total';
  }

  getRateClass(product: any): string {

    let rateClass = '';
    switch(this.categoryId) {

      case 1:
        rateClass = product?.additionalInfo?.rooms[0]?.room?.rateClass;
        break;
      case 2:
        rateClass = product?.rateClass;
        break;
      case 6:
        rateClass = product?.additionalInfo?.tours?.options[0]?.rateClass;
        break;
      case 8:
        rateClass = product['vehicles'][0]['pricing'].rateClass;
        break;
      case 9:
        rateClass = 'NR';
        break;

    }

    return rateClass;
  }

  getDateCancellationPolicy(product: any): Date {
    let dateCancellationPolicy: Date = new Date();
    let cancellationPolicies: any[] = [];
    switch(this.categoryId) {

      case 1:
        cancellationPolicies = product?.additionalInfo?.rooms[0]?.room?.cancellationPolicy;
        dateCancellationPolicy = cancellationPolicies?.find((data: any) => data.amount > 0)?.from;
        break;
      case 2:
        cancellationPolicies = product?.additionalInfo?.carRental?.cancellationPolicies;
        dateCancellationPolicy = cancellationPolicies?.find((data: any) => data.amount > 0)?.from;
        break;
      case 6:
        cancellationPolicies = product?.additionalInfo?.tours?.options[0]?.cancellationPolicies[0]?.cancellationPolicies;
        dateCancellationPolicy = cancellationPolicies?.find((data: any) => data.amount > 0)?.dateFrom;
        break;
      case 8:
        cancellationPolicies = product['vehicles'][0]['timing']['entry']['entryCancellationPolicies'];
        dateCancellationPolicy = cancellationPolicies?.find((data: any) => data.amount > 0)?.from;
        break;
    }

    return dateCancellationPolicy;
  }

  getBlickoins(product: any): number {
          let blickoins = 0;

    switch(this.categoryId) {

      case 1:
        blickoins = product?.additionalInfo?.rooms[0]?.room?.blickoins;
        break;
      case 2:
         blickoins = product?.additionalInfo?.carRental?.profility?.blickoins;
        break;
      case 5:
        blickoins = product?.price?.blickoins || 0;
        break;
      case 6:
      case 9:
        blickoins = this.getBlickoinsAdults(product?.additionalInfo?.tours?.options[0]?.profility);
        break;
      case 8:
        blickoins = product['vehicles'][0]?.profility?.blickoins;
      break;
    }

    return blickoins;
  }

  getViews(result): string {
              let views = '';

    switch(this.categoryId) {

      case 1:
        views = result?.view_hotel;
        break;
      case 2:
        views = result?.views;
        break;
      case 6:
      case 9:
        views = result?.views;
        break;
      case 8:
        views = result?.views;
      break;
    }

    return views;
  }



  onMouseEnter(index: number) {
    this.hoverStates[index] = true;
  }

  onMouseLeave(index: number) {
    this.hoverStates[index] = false;
  }



  // result?.additionalInfo?.carRental?.currency

  initializeValuesForCategory(categoryId: number): void {

    switch(categoryId) {
      case 2:
        this.includesRentacar = initArrayIncludesCoverageRentACar(this.result.additionalInfo.carRental.optionRates.priceCoverages.included);
        break;
    }
  }

  // HOTEL
  getMealsFirstRoom(product: any): string {
    return routeIconsBoardnameHotel(product.additionalInfo.rooms[0].room);
  }

  getMealsNameRoom(product: any): string {
    return boardNameHotel(product.additionalInfo.rooms[0].room);
  }

  getCommentadjective(average: any): any {
    return getCommentadjective(average);
  }

  getBlickoinsAdults(profility: any): number {
    if(profility){
      const blickoins = profility.filter((profility: any) => profility.paxType == 'ADULT')[0]?.blickoins;
      return blickoins;
    }
  }

  getStarsHotels(product: any): any {
    return starsHotels(product?.additionalInfo?.starRating);
  }


  // RENT-A-CAR

  getRatingAcriss(rating: string): string {
    return ratingAccriss(rating);
  }

  typeTransferResult(): string {
    const payload = this.payload.transfers;
    if (payload.pickupLocation.type === 'hotel') {
     return 'hotel';
    } else {
     return 'aeropuerto';
    }
  }

  // TRASLADO
  getLanguages(product: any): string {
     const languagesArr = product[0].amenities.filter(c => c.type === 'Language') || [];
     const languages = this.getLanguageArray(languagesArr);
     return languages.join(', ');
  }

  getLanguangesArr(product: any): string[] {
    const languagesArr = product[0].amenities.filter(c => c.type === 'Language') || [];
     const languages = this.getLanguageArray(languagesArr);
    return languages;
  }

  getLanguageArray(options: any): any[] {
    return languageArrayExperience(options);
  }

  getFlagByLanguageName(language: any): any {
    return flagByLanguageNameExperience(language);
  }


modalClosedemitter(event?: any): void {
  this.modalClosedemitterChild.emit(event);
}

qtyProductValidDecrement(): void {
  this.qtyProductValidDecrementEmmitChild.emit();
}


getExclusiveDeal(product: any): any {
  if(product.additionalInfo.rooms && product.additionalInfo.rooms.length > 0) {

    const firstRoom = product.additionalInfo.rooms[0].room;

    if(firstRoom) {
      return firstRoom.exclusiveDeal;
    } else {
      return null;
    }
  }
}

getVideoUrlInsti(): string | null {

  let url = '';

  switch(this.categoryId) {
    case 1:
      url = this.result?.video_institut;
      break;
    case 6:
      url = this.result?.institutional_video_link || '';
      break;
    case 9:
      url = this.result?.institutional_video_link || '';
  }


  return url !== '' ? url : null;
}

getVideoUrlCommercial(): string | null {

  let url = '';

  switch(this.categoryId) {
    case 1:
      url = this.result?.video_ecomerce;
      break;
    case 6:
      url = this.result?.commercial_video_link || '';
      break;
    case 9:
      url = this.result?.commercial_video_link || '';
  }


  return url !== '' ? url : null;
}

  openModalDetail(flightData: any): void {

    const initialState = {
      flightData,
      payload: this.payload,
      arrayResults: this.arrayResults,
      deferCreation: this.deferFlightCreation
    };

    this.modalRef = this.modalService.show(
      DetailModalFlightResultComponent,
      {
        initialState,
        class: 'modal-lg-flight-detail modal-dialog-centered',
        backdrop: 'static',
        keyboard: false
      }
    );

    if (this.deferFlightCreation) {
      this.modalRef.content.fareSelectedForLeg.subscribe((selection: { offer: any; fare: any }) => {
        this.flightFareSelectedForLeg.emit(selection);
      });
      return;
    }

    this.modalRef.content.productAdded.subscribe(() => {
      this.qtyProductValidDecrement();
      this.modalClosedemitter('success');
    });
  }

}
